<template>
  <div style="height: 100%;">
    <transition name="router-fade" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="router-fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss">
  @import './styles/main.scss';
  .router-fade-enter-active, .router-fade-leave-active {
      transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
      opacity: 0;
  }
  .slider-pagination>.slider-pagination-item{
    width: .4rem;
    height: .05rem;
    border-radius: inherit;
  }
  body{
    background: #fff!important;
    margin-top: -1px!important;
  }
  .g-scrollview:after{
    height: 1rem;
  }
  .textarea .yd-cell:after{
    content: '';
    border: 0;
  }
  .loveMyloveCoinHistory{
    .yd-tab-nav .yd-tab-active:before{
      height: 72%;
      bottom: 14%;
      border: 1px solid;
      background-color: transparent;
    }
    .yd-tab-nav-item:not(:last-child):after{
      content: none;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?90929828